import React, { useEffect, useRef } from 'react';
import fetch from 'isomorphic-fetch';
import Cookies from 'js-cookie';
import { useQuery } from 'react-query';
import placeMadgexSnippet from './place-madgex-snippet';

/** Not directly used, but helpful for debugging */
export const madgexDivId = 'madgex-confirm';

export default function MadgexConfirm({ advertId }: { advertId: number }) {

    const elRef = useRef<HTMLDivElement>(null);

    const { data: snippet } = useQuery(`madgex-confirm-${advertId}`, async () => {
        const { href: vipUrl } = window.location;
        const response = await fetch(getFetchUrl(advertId, vipUrl), getFetchOptions());
        if (response.status === 200) {
            const { snippet, error } = await response.json();
            if (!error && typeof snippet === 'string') {
                return snippet;
            }
        }
        return null;
    });

    useEffect(() => {
        snippet && elRef.current && placeMadgexSnippet(snippet, elRef.current)
    }, [snippet]);

    return <div ref={elRef} id={madgexDivId} />;
};

export function getFetchUrl(vipAdvertId: number, vipUrl: string) {
    return `/vip/jobs/analytics/${vipAdvertId}?${new URLSearchParams({ vipUrl })}`;
}

export function getFetchOptions(): RequestInit {
    return {
        headers: {
            'Cookie': `m_sid=${Cookies.get('m_sid') || ''}; m_au=${Cookies.get('m_au') || ''}`,
            'X-Requested-With': 'XMLHttpRequest',
        },
        referrerPolicy: 'unsafe-url',
    };
}
